module.exports = __webpack_public_path__ + "img/Comment-Logo.ef370900.svg";